module.exports = __webpack_public_path__ + "static/img/cabinet24_16.3e093b2a.gif";